//import axios from "axios";
import ApiService from "@/core/services/api.service";

export const OBTENER_RESPUESTAS_MUNI = "obtenerRespuestasMunicipalidad";
export const REGISTRAR_RESPUESTAS_MUNI = "registrarRespuestasMuni";



// mutation types
export const SET_RESPUESTAS_MUNI = "setRespuestaMuni";


const state = {
    respuestasMuni:[],
}

// actions

const actions = {


    /**
     * Obtener las respuestas de la municipalidad
     * @param {*} context 
     * @param {*} oletaAsignacionId 
     * @returns 
     */
    async [OBTENER_RESPUESTAS_MUNI](context, boletaAsignacionId) {

        return new Promise(resolve => {
           
            ApiService.query(`apiconsume/obtener?endpoint=api/RespuetasMuni/${boletaAsignacionId}`, '')
                .then(({ data }) => {
                    if(data.status===200){
                        context.commit(SET_RESPUESTAS_MUNI, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },



    /**
     * Registrar las respuestas de una municipalidad por boleta
     * @param {*} context 
     * @param {*} datosRespuestas 
     * @returns 
     */
    async [REGISTRAR_RESPUESTAS_MUNI](context, datosRespuestas){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/RespuetasMuni`, datosRespuestas)
                .then(({ data }) => {
                    if(data.status===200){
                        context.commit(SET_RESPUESTAS_MUNI, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },
}


const mutations = {
    [SET_RESPUESTAS_MUNI](state, data) {
        state.respuestasMuni = data;
    },
}


export default {
    state,
    actions,
    mutations
}